import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import ArgonDashboard from './plugins/argon-dashboard'
import VueFormulate from '@braid/vue-formulate'
import { es } from '@braid/vue-formulate-i18n'
import axios from 'axios'
import { auth } from './firebase'
import store from "./store";


Vue.prototype.$dirServerParam = 'https://us-central1-aidc-ing.cloudfunctions.net/generate_parameters'
Vue.prototype.$dirServerMemoria = 'https://us-central1-aidc-ing.cloudfunctions.net/create_report'
Vue.prototype.$dirServerUpdateTable = 'https://us-central1-aidc-ing.cloudfunctions.net/get_projects_table'
Vue.prototype.$dirServerDownload = 'https://us-central1-aidc-ing.cloudfunctions.net/download_file'
Vue.prototype.$dirServerComm = 'https://us-central1-aidc-ing.cloudfunctions.net/feedback'
Vue.prototype.$dirLocalServer = 'http://127.0.0.1:8090/'


auth.onIdTokenChanged( async (user) => {
  store.dispatch("fetchUser", user);
  if (user !== null){
    user.getIdToken().then( token => {
      store.dispatch("fetchUserId", token)
    })
  }
});

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.use(ArgonDashboard)
Vue.use(VueFormulate,  {
  plugins: [ es ],
  locale: 'es'
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
